import { render, staticRenderFns } from "./view.vue?vue&type=template&id=3dfea387&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=3dfea387&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfea387",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dfea387')) {
      api.createRecord('3dfea387', component.options)
    } else {
      api.reload('3dfea387', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=3dfea387&scoped=true", function () {
      api.rerender('3dfea387', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/traddingWitness/openBidWitness/view.vue"
export default component.exports